import { useCallback, useState } from "react";

const DEFAULT_MAX_MESSAGES = 4;

export function useMarqueeMessages(maxMessages: number = DEFAULT_MAX_MESSAGES) {
  const [messages, setMessages] = useState<string[]>([]);

  const pushMessage = useCallback(
    (message: string) => {
      if (!message) {
        return;
      }

      setMessages((prev) => {
        const next = [...prev, message];
        return next.length > maxMessages
          ? next.slice(next.length - maxMessages)
          : next;
      });
    },
    [maxMessages]
  );

  const clearMessages = useCallback(() => {
    setMessages((prev) => {
      if (prev.length === 0) {
        return prev;
      }
      return [];
    });
  }, []);

  return {
    messages,
    pushMessage,
    clearMessages,
  };
}
